import { Swiper, Navigation, Pagination } from 'swiper/dist/js/swiper.esm.js';
Swiper.use([Navigation, Pagination]);
import { v4 as uuidv4 } from 'uuid';
import TabsWithSelect from "../../../components/base/tabs-with-select";
import Accordion from "../../../components/accordion";
import ModalForm from "../../../components/base/forms/modal-form";
import Api from "../../../lib/api";
import ReviewsSlider from "../../../components/reviews-slider";
import {AnalyticsService} from "../../../services/analytics-service";

export default class PageModule {
	constructor() {
		this.initTabs();
		this.initFAQAccordion();
		this.initReviewsSlider();
		this.initConsultationForm();
		this.initPublicationSliders();
	}

	initTabs() {
		const tabsComponent = new TabsWithSelect({
			$root: document.getElementById('technologiesTabs')
		})
	}

	initFAQAccordion() {
		const accordion = new Accordion('accordion-faq');
	}

	initReviewsSlider() {
		const reviewsSlider = new ReviewsSlider();
	}

	initConsultationForm() {
		const form = new ModalForm({
			formId: 'corped-consultation',
			uri: '/2.0/courses/registration',
			data: {
				city: craft.env.cityId || Api.currentCityId,
				fbp: costorage.get('_fbp') ? costorage.get('_fbp') : null,
				fbc: costorage.get('_fbc') ? costorage.get('_fbc') : null,
				referrer: location.href
			},
			fieldsOptions: [
				{
					name: 'course-type',
					sendable: false
				}
			],
			$modalTriggers: Array.from(document.querySelectorAll('.btn-consultation')),
			subscriptions: [
				{
					event: 'afterInit',
					callback: ({ detail }) => {
						const courseField = detail.getField('course');
						courseField.hide();
					}
				},
				{
					field: 'course-type',
					event: 'valueChange',
					callback: ({ detail }) => {
						if (detail !== 'standard' && detail !== 'individual') {
							return;
						}

						const courseField = form.getField('course');

						if (detail === 'standard') {
							courseField.show();
							form.uri = '/2.0/courses/registration';
						} else {
							courseField.hide();
							form.uri = '/1.0/b2b/corped';
						}

						form.validate();
					}
				},
				{
					event: 'beforeSubmit',
					callback: () => {
						const dataLayerEventData = {
							event: 'b2b_consultation_form',
							formId: form.formId,
							phone: form.data.tel,
							email: form.data.email
						};

						if (form.uri === '/2.0/courses/registration') {
							const conversionId = uuidv4();
							const owoxUserId = costorage.get('ouid');

							form.addData({ conversionId });

							if (owoxUserId) {
								form.addData({ owoxUserId });
							}

							dataLayerEventData.conversion_id = conversionId;
						}

						const $formTitle = form.$root.querySelector('.form_title');

						if ($formTitle) {
							dataLayerEventData.formName = $formTitle.textContent;
						}

						AnalyticsService.sendEvent('b2b_consultation_form', dataLayerEventData);
					}
				}
			]
		})
	}

	initPublicationSliders() {
		const $sliders = document.querySelectorAll('.publication-group_slider');

		if (!$sliders.length) return;

		$sliders.forEach(($slider) => {
			const $container = $slider.querySelector('.swiper-container');
			const $slides = $slider.querySelectorAll('.swiper-slide');

			if (!$slides.length) return;

			const config = {
				init: false,
				navigation: {
					nextEl: $slider.querySelector('.swiper-nav.-next'),
					prevEl: $slider.querySelector('.swiper-nav.-prev')
				},
				pagination: {
					el: $slider.querySelector('.swiper-bullets'),
					type: 'bullets',
					clickable: true
				},
				slidesPerView: 3,
				spaceBetween: 30,
				breakpoints: {
					1024: {
						slidesPerView: 2,
						spaceBetween: 30
					},
					600: {
						spaceBetween: 30,
						slidesPerView: 1
					},
					500: {
						spaceBetween: 15,
						slidesPerView: 1
					}
				}
			};

			const swiper = new Swiper($container, config);

			swiper.on('init', function () {
				const $bullets = swiper.pagination.bullets;

				if ($bullets.length > 1) {
					$slider.classList.add('-pagination');
				}
			});

			swiper.init();
		});
	}
}